import helpers from "./helpers";
import { httpRequest } from "./httpService";
import Swal from 'sweetalert2';

export async function getEnums(url = ''){
    try {
        const endpoint = helpers.createUrl(url)
        const res = await httpRequest(endpoint, "GET", {}, true)
        const result = res?.cancellation_reasons || []
        return result
    } catch (err) {
        Swal.fire({
            // title: "Error!",
            text: err.message,
            icon: "error",
            confirmButtonText: "OK",
        });
        console.error('Error fetching enums:', err)
        // setLoading(0) — same note as above
        return []
    }
}

export async function getItemEnums(){
    try {
        const endpoint = helpers.createUrl('V1/enums/item')
        const res = await httpRequest(endpoint, "GET", {}, true)
        const result = res || []
        return result
    } catch (err) {
        Swal.fire({
            // title: "Error!",
            text: err.message,
            icon: "error",
            confirmButtonText: "OK",
        });
        //console.error('Error fetching data:', err)
        // setLoading(0) — same note as above
        return []
    }
}

export async function getServiceHubEnums(){
    try {
        const endpoint = helpers.createServiceHubUrl('v1/enums')
        const res = await httpRequest(endpoint, "GET", {}, true)
        const result = res || []
        return result
    } catch (err) {
        Swal.fire({
            // title: "Error!",
            text: err.message,
            icon: "error",
            confirmButtonText: "OK",
        });
        //console.error('Error fetching data:', err)
        // setLoading(0) — same note as above
        return []
    }
}

export async function getServiceHubData(url = ''){
    try {
        const endpoint = helpers.createServiceHubUrl(url)
        const res = await httpRequest(endpoint, "GET", {}, true)
        const result = res || []
        return result
    } catch (err) {
        Swal.fire({
            // title: "Error!",
            text: err.message,
            icon: "error",
            confirmButtonText: "OK",
        });
        //console.error('Error fetching data:', err)
        // setLoading(0) — same note as above
        return []
    }
}

export async function getApiData(endpoint, display_alert = true){
    try {
        const res = await httpRequest(endpoint, "GET", {}, true)
        return res
    } catch (err) {
        if(display_alert){
            Swal.fire({
                // title: "Error!",
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
        return err
    }
}

export async function postApiData(endpoint, post_data, display_alert = true){
    try {
        const res = await httpRequest(endpoint, "POST", {postdata: post_data}, true)
        return res
    } catch (err) {
        if(display_alert){
            Swal.fire({
                // title: "Error!",
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
        return err
    }
}